import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { KnBrSpinnerEffects } from './kn-br-spinner.effects';

@NgModule({
  imports: [EffectsModule.forFeature([KnBrSpinnerEffects])],
})
export class KnBrSpinnerStateModule {}
